import { checkTargetByHtml } from '@flowus/common/dom';
import { useEffect } from 'react';
import { MOUSE_RIGHT, TABLE_CELL_MENU } from 'src/common/const';
import { ID_HOVER_MENU, ID_RECORD_HOVER_MENU } from 'src/hooks/page/use-dnd/helper';
import { cleanSelectBlock } from 'src/hooks/utils/clean-select';
import { simpleTableActions } from 'src/redux/reducers/simple-table';
import { cache, dispatch } from 'src/redux/store';
import { $appUiStateCache } from 'src/services/app';
import { getDynamicPageId, useGetPageId } from 'src/utils/getPageId';
import { handleShiftMouseDown } from './handle-shift-mousedown';

export const useHandleMouseDown = () => {
  const pageId = useGetPageId();
  const isInRight = getDynamicPageId('right') === pageId;

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      const { target, button } = event;

      const isRightClick = button === MOUSE_RIGHT;

      if (isRightClick) {
        event.preventDefault();
        return;
      }

      if (event.shiftKey) {
        handleShiftMouseDown(event, isInRight);
        return;
      }
      if ((event.target as HTMLElement).closest('.focused-cell')) {
        // 点在选中的单元格上不执行后面的代码
        return;
      }
      // TODO kcsx 有弹窗的时候，点击点击不清除选中的block，
      // 实验阶段。目前用在folder页面的多选里
      // 同步块右上角的菜单是openModal打开的，粘贴点击块内，会导致选中的块无法取消，有光标聚焦到富文本的情况下点击backspace会删除整个块
      // if (openModalListId.length > 0) {
      //   return;
      // }

      // 菜单打开时不取消选择
      if ($appUiStateCache.$blockMenuListId) return;

      if (target) {
        const checkTarget = (t: HTMLElement) => {
          // 点击 6个点 时不触发
          if ([ID_HOVER_MENU, ID_RECORD_HOVER_MENU].includes(t.id)) return true;
          // 点击 todo 时不取消
          if (t?.classList?.contains('todo')) return true;
          if (['IcCheckbox', 'IcCheckboxCheck'].includes(t?.getAttribute('data-icon') ?? '')) {
            return true;
          }
          if (
            t.closest('[data-no-cancel-selected]') &&
            !t.closest('[data-no-cancel-selected="false"]')
          ) {
            return true;
          }
          if (t.closest('.disable-cancel-selected')) {
            return true;
          }
          return false;
        };

        const check = checkTargetByHtml(target as HTMLElement, checkTarget);
        if (check) {
          return;
        }
      }

      const isTableMenuOpen = document.querySelector(`[data-modal-id="${TABLE_CELL_MENU}"]`);
      if (isTableMenuOpen) return;

      if (cache.simpleTable.chosenCells) {
        dispatch(simpleTableActions.update({ activityTableId: undefined, chosenCells: undefined }));
      }

      if (cache.ui.selectedBlocks.length === 0 && cache.ui.selectedCells.length === 0) return;
      cleanSelectBlock();
    };

    document.addEventListener('mousedown', handleMouseDown, true);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown, true);
    };
  }, [isInRight]);
};
